import { useContext } from "react"
import { ContentHeader } from "./styles"

import { InfoFiscaleContext } from "../../../context"

export function Header() {
  const { handleComponentDisplay, enable, enableIssqn, setEnableIssqn } = useContext(InfoFiscaleContext)

  return (
    <ContentHeader className="fiscal-tax-tabs" role="tablist" aria-label="Seções fiscais">
      <button type="button" className={!enable.description ? 'active' : ''} onClick={() => handleComponentDisplay("description")}>Geral</button>
      <button type="button" className={!enable.icms ? 'active' : ''} onClick={() => handleComponentDisplay("icms")}>ICMS</button>
      <button type="button" className={!enable.ipi ? 'active' : ''} onClick={() => handleComponentDisplay("ipi")}>IPI</button>
      <button type="button" className={!enable.pis ? 'active' : ''} onClick={() => handleComponentDisplay("pis")}>PIS</button>
      <button type="button" className={!enable.cofins ? 'active' : ''} onClick={() => handleComponentDisplay("cofins")}>COFINS</button>
      <div className={`fiscal-issqn-tab ${!enable.issqn ? 'active' : ''}`}>
        <button type="button" onClick={() => handleComponentDisplay("issqn")}>ISSQN</button>
        <label title="Habilitar ISSQN"><input type="checkbox" checked={enableIssqn} onChange={(event) => setEnableIssqn(event.target.checked)} /><span /></label>
      </div>
      <button type="button" className={!enable.information ? 'active' : ''} onClick={() => handleComponentDisplay("information")}>Informações</button>
    </ContentHeader>
  )
}
